var configStep = 1,
	configOptions = $('.configurator-option'),
    configSections = $('.configurator-step'),
	configBackWrapper = $('.configurator-back-wrapper'),
	configBackBtn = $('.configurator-back-button'),
	currentStepValue = [],
	configUSPWrapper = $('.configurator-usp-wrapper'),
	progressStep = 0;

function toggleBackWrapper() {
	if(configStep == 1) {
		configBackWrapper.hide();
	} else {
		configBackWrapper.show();
	}
}	

configOptions.on('click', function () {
  	var configOptionValue = $(this).data('value');

	currentStepValue.push($(this).closest('.configurator-step').data('value'));

    console.log(currentStepValue);

	if(configOptionValue !== '') {
		configStep++;
		toggleBackWrapper();
		toggleShowUSP();

		configSections.each(function () {
			var configSectionValue = $(this).data('value');

			if(configOptionValue == configSectionValue) {
				$(this).show();
			} else {
				$(this).hide();
			}  
		});
	}
});

function executeGoBack() {
	configSections.each(function () {
		var configSectionStep = $(this).data('step'),
			configSectionValue = $(this).data('value');

        console.log(configSectionStep, configSectionValue, configStep, currentStepValue);

		if(configSectionStep == configStep && configSectionValue == currentStepValue.slice(-1)) {
			$(this).show();
			currentStepValue.pop();
		} else {
			$(this).hide();
		}
	});
}

function toggleShowUSP() {
	configUSPWrapper.each(function () {
		var configUSPStep = $(this).data('step');

		if(configUSPStep == configStep) {
			$(this).show();
		} else {
			$(this).hide();
		}
	});
}

toggleShowUSP();

configBackBtn.on('click', function () {
	configStep--;
	executeGoBack();
	toggleBackWrapper();
	toggleShowUSP();
});

configOptions.on('click', function () {
	progressStep += progressStepAmount;

	if(progressStep >= 0 && progressStep < 100) {
		$('.configurator-progress').css('width', progressStep + '%');
	}
});

configBackBtn.on('click', function () {
	progressStep -= progressStepAmount;

	if(progressStep >= 0 && progressStep < 100) {
		$('.configurator-progress').css('width', progressStep + '%');
	}
});